document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector("[data-document-listing-page]")) {
        import(/* webpackChunkName: "document-listing" */ "/Features/Documents/js/document-listing-page.js").then(async (module) => {
            const documentListingPage = new module.default();
            await documentListingPage.init();
        });
    }
});